<template>
  <div
    v-if="active"
    class="image-lightbox-overlay fixed inset-0 z-[99999] flex flex-col justify-between"
    style="position: fixed; top: 0; left: 0; right: 0; bottom: 0; background-color: rgba(15, 23, 42, 0.95); z-index: 99999; display: flex; flex-direction: column; justify-content: space-between; user-select: none;"
    @click.self="fechar"
  >
    <!-- Top Bar: Counter, Info & Actions -->
    <div
      class="lightbox-topbar p-4 flex items-center justify-between"
      style="display: flex; align-items: center; justify-content: space-between; padding: 16px 24px; background: linear-gradient(to bottom, rgba(0,0,0,0.8), transparent); color: white;"
    >
      <div style="display: flex; align-items: center; gap: 12px;">
        <span
          style="background-color: rgba(255, 255, 255, 0.15); backdrop-filter: blur(4px); padding: 4px 12px; border-radius: 9999px; font-size: 13px; font-weight: 700; letter-spacing: 0.5px;"
        >
          {{ (currentIndex + 1) }} / {{ totalImagens }}
        </span>
        <span
          v-if="nomeImagemAtual"
          style="font-size: 13px; color: #CBD5E1; max-width: 400px; text-overflow: ellipsis; white-space: nowrap; overflow: hidden;"
          :title="nomeImagemAtual"
        >
          {{ nomeImagemAtual }}
        </span>
        <span
          v-if="tamanhoImagemAtual"
          style="font-size: 11px; color: #94A3B8;"
        >
          ({{ tamanhoImagemAtual }})
        </span>
      </div>

      <div style="display: flex; align-items: center; gap: 10px;">
        <!-- Download Button -->
        <button
          type="button"
          class="lightbox-btn"
          @click="baixarAtual"
          title="Baixar esta imagem"
          style="background-color: rgba(255, 255, 255, 0.15); border: 1px solid rgba(255, 255, 255, 0.2); color: white; border-radius: 8px; padding: 6px 14px; font-size: 12px; font-weight: 600; cursor: pointer; display: flex; align-items: center; gap: 6px;"
        >
          <vs-icon icon="cloud_download" size="16px"></vs-icon>
          <span>Baixar</span>
        </button>

        <!-- Bulk Download Button -->
        <button
          v-if="totalImagens > 1"
          type="button"
          class="lightbox-btn-bulk"
          @click="baixarTodas"
          title="Baixar todas as imagens anexadas"
          style="background-color: #2563EB; border: 1px solid #3B82F6; color: white; border-radius: 8px; padding: 6px 14px; font-size: 12px; font-weight: 600; cursor: pointer; display: flex; align-items: center; gap: 6px;"
        >
          <vs-icon icon="archive" size="16px"></vs-icon>
          <span>Baixar Todas ({{ totalImagens }})</span>
        </button>

        <!-- Close Button -->
        <button
          type="button"
          class="lightbox-close-btn"
          @click="fechar"
          title="Fechar visualizador (Esc)"
          style="background-color: rgba(239, 68, 68, 0.2); border: 1px solid rgba(239, 68, 68, 0.4); color: #FCA5A5; border-radius: 8px; width: 34px; height: 34px; display: flex; align-items: center; justify-content: center; cursor: pointer; font-size: 18px;"
        >
          ✕
        </button>
      </div>
    </div>

    <!-- Main Image Display Area with Left & Right Arrow Buttons -->
    <div
      class="lightbox-main-content flex-1 flex items-center justify-between"
      style="display: flex; align-items: center; justify-content: space-between; padding: 0 16px; flex: 1; min-height: 0; position: relative;"
      @click.self="fechar"
    >
      <!-- Seta Esquerda (Anterior) -->
      <button
        v-if="totalImagens > 1"
        type="button"
        class="lightbox-nav-arrow arrow-left"
        @click.stop="anterior"
        title="Imagem anterior (Seta esquerda)"
        style="background-color: rgba(255, 255, 255, 0.15); backdrop-filter: blur(8px); border: 1px solid rgba(255, 255, 255, 0.25); color: white; border-radius: 50%; width: 50px; height: 50px; display: flex; align-items: center; justify-content: center; cursor: pointer; z-index: 10; transition: all 0.2s;"
      >
        <span style="font-size: 24px; font-weight: bold; line-height: 1;">‹</span>
      </button>
      <div v-else style="width: 50px;"></div>

      <!-- Imagem Centralizada com Zoom Suave -->
      <div
        class="lightbox-img-wrapper"
        style="display: flex; align-items: center; justify-content: center; max-height: calc(85vh - 120px); max-width: calc(100vw - 160px); margin: 0 auto; position: relative;"
        @click.self="fechar"
      >
        <video
          v-if="ehVideoAtual"
          :src="urlImagemAtual"
          controls
          autoplay
          style="max-height: calc(85vh - 130px); max-width: 100%; border-radius: 10px; box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.7); border: 1px solid rgba(255, 255, 255, 0.1);"
        ></video>
        <img
          v-else-if="urlImagemAtual"
          :src="urlImagemAtual"
          :alt="nomeImagemAtual || 'Evidência do Ticket'"
          class="lightbox-img animate-in fade-in zoom-in-95 duration-200"
          style="max-height: calc(85vh - 130px); max-width: 100%; object-fit: contain; border-radius: 10px; box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.7); border: 1px solid rgba(255, 255, 255, 0.1);"
        />
      </div>

      <!-- Seta Direita (Próxima) -->
      <button
        v-if="totalImagens > 1"
        type="button"
        class="lightbox-nav-arrow arrow-right"
        @click.stop="proximo"
        title="Próxima imagem (Seta direita)"
        style="background-color: rgba(255, 255, 255, 0.15); backdrop-filter: blur(8px); border: 1px solid rgba(255, 255, 255, 0.25); color: white; border-radius: 50%; width: 50px; height: 50px; display: flex; align-items: center; justify-content: center; cursor: pointer; z-index: 10; transition: all 0.2s;"
      >
        <span style="font-size: 24px; font-weight: bold; line-height: 1;">›</span>
      </button>
      <div v-else style="width: 50px;"></div>
    </div>

    <!-- Bottom Thumbnail Strip (se houver mais de 1 imagem) -->
    <div
      v-if="totalImagens > 1"
      class="lightbox-thumbnails-bar p-3"
      style="padding: 12px 24px; background: linear-gradient(to top, rgba(0,0,0,0.85), transparent); display: flex; justify-content: center; gap: 8px; overflow-x: auto;"
    >
      <div
        v-for="(item, idx) in normalizedImages"
        :key="idx"
        @click.stop="irPara(idx)"
        class="thumb-item"
        :style="{
          width: '56px',
          height: '56px',
          borderRadius: '8px',
          overflow: 'hidden',
          cursor: 'pointer',
          border: idx === currentIndex ? '2px solid #38BDF8' : '1px solid rgba(255, 255, 255, 0.2)',
          opacity: idx === currentIndex ? '1' : '0.5',
          transform: idx === currentIndex ? 'scale(1.08)' : 'scale(1)',
          transition: 'all 0.2s'
        }"
      >
        <video
          v-if="ehVideoItem(item.url)"
          :src="item.url"
          style="width: 100%; height: 100%; object-fit: cover; pointer-events: none;"
        ></video>
        <img
          v-else
          :src="item.url"
          style="width: 100%; height: 100%; object-fit: cover;"
          :alt="'Thumb ' + (idx + 1)"
        />
      </div>
    </div>
    <div v-else style="height: 20px;"></div>
  </div>
</template>

<script>
export default {
  name: "ImageLightboxModal",
  props: {
    active: {
      type: Boolean,
      default: false
    },
    images: {
      type: Array,
      default: function() {
        return [];
      }
    },
    initialIndex: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      currentIndex: 0
    };
  },
  watch: {
    active(val) {
      if (val) {
        this.currentIndex = this.initialIndex || 0;
        window.addEventListener("keydown", this.onKeyDown);
      } else {
        window.removeEventListener("keydown", this.onKeyDown);
      }
    },
    initialIndex(val) {
      this.currentIndex = val || 0;
    }
  },
  beforeDestroy() {
    window.removeEventListener("keydown", this.onKeyDown);
  },
  computed: {
    normalizedImages() {
      if (!this.images || this.images.length === 0) return [];
      var result = [];
      for (var i = 0; i < this.images.length; i++) {
        var item = this.images[i];
        if (typeof item === "string") {
          result.push({
            url: item,
            nome: "Evidência " + (i + 1),
            tamanho: ""
          });
        } else if (item && typeof item === "object") {
          result.push({
            url: item.preview || item.url || "",
            nome: item.nome || item.name || ("Evidência " + (i + 1)),
            tamanho: item.tamanhoFormatado || item.tamanho || ""
          });
        }
      }
      return result;
    },
    totalImagens() {
      return this.normalizedImages.length;
    },
    imagemAtual() {
      if (this.normalizedImages.length === 0) return null;
      var idx = this.currentIndex;
      if (idx < 0) idx = 0;
      if (idx >= this.normalizedImages.length) idx = this.normalizedImages.length - 1;
      return this.normalizedImages[idx];
    },
    urlImagemAtual() {
      return this.imagemAtual ? this.imagemAtual.url : "";
    },
    nomeImagemAtual() {
      return this.imagemAtual ? this.imagemAtual.nome : "";
    },
    tamanhoImagemAtual() {
      return this.imagemAtual ? this.imagemAtual.tamanho : "";
    },
    ehVideoAtual() {
      return this.ehVideoItem(this.urlImagemAtual);
    }
  },
  methods: {
    ehVideoItem(url) {
      if (!url) return false;
      var clean = String(url).split('?')[0].toLowerCase();
      return /\.(mp4|webm|mov|mkv|avi)$/.test(clean) || String(url).startsWith('data:video/');
    },
    anterior() {
      if (this.totalImagens <= 1) return;
      if (this.currentIndex > 0) {
        this.currentIndex--;
      } else {
        this.currentIndex = this.totalImagens - 1; // loop
      }
    },
    proximo() {
      if (this.totalImagens <= 1) return;
      if (this.currentIndex < this.totalImagens - 1) {
        this.currentIndex++;
      } else {
        this.currentIndex = 0; // loop
      }
    },
    irPara(idx) {
      if (idx >= 0 && idx < this.totalImagens) {
        this.currentIndex = idx;
      }
    },
    fechar() {
      this.$emit("update:active", false);
      this.$emit("close");
    },
    onKeyDown(e) {
      if (!this.active) return;
      if (e.key === "Escape" || e.keyCode === 27) {
        this.fechar();
      } else if (e.key === "ArrowLeft" || e.keyCode === 37) {
        this.anterior();
      } else if (e.key === "ArrowRight" || e.keyCode === 39) {
        this.proximo();
      }
    },
    baixarAtual() {
      if (!this.urlImagemAtual) return;
      var link = document.createElement("a");
      link.href = this.urlImagemAtual;
      link.download = this.nomeImagemAtual || "evidencia_ticket.png";
      link.target = "_blank";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
    baixarTodas() {
      var self = this;
      for (var i = 0; i < this.normalizedImages.length; i++) {
        (function(index) {
          setTimeout(function() {
            var item = self.normalizedImages[index];
            if (item && item.url) {
              var link = document.createElement("a");
              link.href = item.url;
              link.download = item.nome || ("evidencia_" + (index + 1) + ".png");
              link.target = "_blank";
              document.body.appendChild(link);
              link.click();
              document.body.removeChild(link);
            }
          }, index * 400);
        })(i);
      }
    }
  }
};
</script>

<style scoped>
.lightbox-btn:hover {
  background-color: rgba(255, 255, 255, 0.25) !important;
}
.lightbox-btn-bulk:hover {
  background-color: #1D4ED8 !important;
}
.lightbox-close-btn:hover {
  background-color: rgba(239, 68, 68, 0.4) !important;
}
.lightbox-nav-arrow:hover {
  background-color: rgba(255, 255, 255, 0.3) !important;
  transform: scale(1.1);
}
</style>
